import {
  STORE_START,
  STORE_END,
  STORE_SUCCESS,
  STORE_FAIL,
  STORE_CLEAR,
  STORE_SET_DATA,
  STORE_UPDATE_DATA,
  STORE_GET_COMPLEATED_TESTS,
  SET_STORE_ALERT,
  CLEAR_STORE_ALERT,
} from "../actions/actionTypes";

const initialState = {
  error: null,
  loading: false,
  storeTests: {
    "beginner-tests": {
      data: [],
      lastFetchedType: null,
      emptyResponse: false,
      totalCompleatedTests: 0,
    },
  },
  storeAlerts: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case STORE_START:
      return {
        ...state,
        loading: true,
      };
    case STORE_END:
      return {
        ...state,
        loading: false,
      };
    case STORE_SUCCESS:
      return {
        ...state,
        error: false,
      };
    case STORE_FAIL:
      return {
        ...state,
        error: payload,
      };
    case SET_STORE_ALERT:
      return {
        ...state,
        storeAlerts: [...state.storeAlerts, payload],
      };
    case CLEAR_STORE_ALERT:
      return {
        ...state,
        storeAlerts: payload,
      };
    case STORE_SET_DATA:
      return {
        ...state,
        storeTests: {
          ...state.storeTests,
          "beginner-tests": {
            ...state.storeTests["beginner-tests"],
            data: [...state.storeTests["beginner-tests"].data, ...payload.data],
            lastFetchedType: payload.fetchedTestType,
            emptyResponse: payload.emptyResponse,
          },
        },
      };
    case STORE_UPDATE_DATA:
      return {
        ...state,
        storeTests: {
          ...state.storeTests,
          "beginner-tests": {
            ...state.storeTests["beginner-tests"],
            data: payload,
          },
        },
      };
    case STORE_GET_COMPLEATED_TESTS:
      return {
        ...state,
        storeTests: {
          ...state.storeTests,
          "beginner-tests": {
            ...state.storeTests["beginner-tests"],
            totalCompleatedTests: payload,
          },
        },
      };
    case STORE_CLEAR:
      return initialState;
    default:
      return state;
  }
};
